<script lang="ts">
import ApocButton from '@/components/common/ApocButton.vue';
import AppConfig from '@/constants';
import { initStore } from '@/stores/store-manager';
import { goAuthor } from '@/utils/apoc-utils';
import { loadLocalData } from '@/utils/common-util';
import { ssoLogin } from '@/utils/sso-login';
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import ApocImageSet from '@/components/common/ApocImageSet.vue';

// content 페이지의 상단 배너
export default defineComponent({
	name: 'ContentBanner',
	components: { ApocImageSet, ApocButton },
	setup() {
		const storeManager = initStore();
		const { t } = useI18n({ useScope: 'global' });

		//  * 로그인 체크
		const onCheckLoginUser = () => {
			const token = loadLocalData(AppConfig.KEYS.CONST.LOGIN_TOKEN);
			const user = loadLocalData(AppConfig.KEYS.CONST.LOGIN_USER);
			if (token && user) {
				const param = {
					authorUrl: `${AppConfig.AUTHOR_HOST}author` + `?lang=${loadLocalData(AppConfig.KEYS.CONST.CHANGE_LANG)}&destination=main`,
					ctx: JSON.stringify({
						lang: loadLocalData(AppConfig.KEYS.CONST.CHANGE_LANG),
						isNew: true,
					}),
				};
				goAuthor(param, storeManager);
			} else {
				window.alert(t('msg.ALERT_JUST_LOGIN'));
				ssoLogin(true);
			}
		};

		return {
			t,

			onCheckLoginUser,
		};
	},
});
</script>

<template>
	<div class="sub-banner-wrapper">
		<div class="sub-banner">
			<div class="contents-img-wrapper">
				<div class="col">
					<div class="content-img"><apoc-image-set src="/assets/images/banner/portfolio.webp" /></div>
					<div class="content-img" id="bag-gif">
						<video autoplay loop muted playsinline src="/assets/images/banner/bag.mp4"></video>
					</div>
				</div>
				<div class="col">
					<div class="content-img single">
						<video autoplay loop muted playsinline src="/assets/images/banner/key.mp4"></video>
					</div>
				</div>
				<div class="col">
					<div class="content-img">
						<apoc-image-set src="/assets/images/banner/3d.webp" />
					</div>
					<div class="content-img">
						<video autoplay loop muted playsinline src="/assets/images/banner/ar_dragon.mp4"></video>
					</div>
				</div>
			</div>
			<div class="sub-banner-right">
				<div>{{ t('layout.subBanner.title') }}</div>
				<div>
					<strong>{{ t('layout.subBanner.sub-text') }}</strong>
				</div>
				<apoc-button class="make-btn" :is-primary="true" :on-click="onCheckLoginUser">{{ t('layout.subBanner.studio-btn') }}</apoc-button>
			</div>
		</div>
	</div>
</template>

<style scoped></style>
